import React, {PureComponent} from "react";
import "./Footer.scss";
import ClientConfigurationHelper from "../../configuration/ClientConfigurationHelper";

class Footer extends PureComponent {
    getYear() {
        return new Date().getFullYear();
    }
    render() {
        const clientLinks = ClientConfigurationHelper.getClientSiteLinks();
        const showSeparator = clientLinks.terms && clientLinks.privacy_policy;
        return <footer className="tvp-footer">
            <div className={"container d-flex justify-content-center"}>
                <span className={"copyright"}>© {this.getYear()} {ClientConfigurationHelper.getExperienceTitle()} - All Rights Reserved</span>
                <div className={"terms-policy"}>
                    {clientLinks.terms && <a href={clientLinks.terms || "#"}>Terms of Use</a>} {showSeparator && "|"} {clientLinks.privacy_policy && <a href={clientLinks.privacy_policy || "#"}>Privacy Policy</a>}
                </div>
            </div>
        </footer>
    }
}

export default Footer;